import {contactUsService} from './contact-us.service';
import {formValidations} from '../../../widget/FormValidations.js';
import data from '../../../assets/json/contactus/contactus.json';
import { CONFIG } from '../../../config.js';

export const contactUsScript = {
	initState,
	setTourPackage,
	setCustomizedTour,
	setName,
	setContactNumber,
	setEmailAddress,
	setMessage,
	setTermsOfAgreement,
	reCaptchaCallback,
	sendEmail,
	validateGoogleCatpcha
};

function initState () {
	return {
		open: true,
		officers: data.contactdetails,
		termsOfAgreement: false,
		tourPackage: null,
		customizedTour:'',
		name: '',
		contactNumber: '',
		emailAddress: '',
		message: '',
		nameError: false,
		contactNumberError: false,
		emailAdError: false,
		messageError: false,
		nameMsgError: '',
		contactNumberMsgError: '',
		emailAdMsgError: '',
		messageMsgError: '',
		termsErrorMsg:'',
		loading: false,
		success: false,
		disableSubmit: false,
		disableCaptcha: false,
		validCaptcha: false,
		captchaResponse: '',
		errorMsg: ''
	}
}

function resetState () {	
	return { 
		tourPackage: null,
		customizedTour:'',
		name: '',
		contactNumber: '',
		emailAddress: '',
		message: '',
		termsOfAgreement: false,
		nameError: false,
		contactNumberError: false,
		emailAdError: false,
		messageError: false,
		tourPackageMsgError: null,
		nameMsgError: '',
		contactNumberMsgError: '',
		emailAdMsgError: '',
		messageMsgError: '',
		termsErrorMsg:'',
		validCaptcha: false,
		captchaResponse: '',
		errorMsg: ''
	};

}

function setTourPackage(value){
	
	return {
		tourPackage: value,
		tourPackageMsgError: formValidations.requiredTourPackageFieldErrorMsg('tour package', value),
		customizedTour:''
	};
	
}

function setCustomizedTour(value){
	return {
		customizedTour: value
		//messageMsgError: formValidations.requiredMessageFieldErrorMsg(value, 0)
	};
	
}

function setName(value){
	return {
		name: value,
		nameMsgError: formValidations.requiredNameFieldErrorMsg('name', value, CONFIG.NAME_LENGTH)
	};
}

function setContactNumber(value){
	return {
		contactNumber: value,
		contactNumberMsgError: formValidations.requiredMobileFieldErrorMsg('contact number', value, CONFIG.MOBILE_LENGTH)
	};
}

function setEmailAddress(value){
	return {
		emailAddress: value,
		emailAdMsgError: formValidations.requiredEmailFieldErrorMsg(value, CONFIG.EMAIL_LENGTH)
	};
}

function setMessage(value){
	return {
		message: value,
		messageMsgError: formValidations.requiredMessageFieldErrorMsg(value, 0)
	};
}

function setTermsOfAgreement(value){
	return {
		termsOfAgreement: value,
		termsErrorMsg: value === false ? 'Terms of use agreement is required' : ''
	};
}


function reCaptchaCallback (data){
	return {
		errorMsg: '',
		captchaErrorMsg: data.captchaErrorMsg,
		captchaResponse: data.captchaResponse,
		validCaptcha: data.validCaptcha
	};
}

function validateGoogleCatpcha(captchaResponse){
	contactUsService.validateGoogleCatpcha(captchaResponse);
}


function sendEmail(self, formData, recaptchaInstance){
	let formIsValid = validateForm(self, formData.tourPackage, formData.name, formData.emailAddress, formData.contactNumber, formData.message, formData.termsOfAgreement);
	if(formIsValid){
		if(formData.validCaptcha){
			self.setState({errorMsg: ''});
			self.setState({loading: true});
			var result = Promise.all([contactUsService.sendEmail(self, formData.emailAddress, formData.body, formData.termsOfAgreement)]);
			result.then((output) => {
				var data = output[0];
				if(data.success){
					self.setState({
						success: data.success,
						disableSubmit: false,
						...resetState()
					});
				}else{
					self.setState({
						disableSubmit: false,
						success: data.success,
						errorMsg: data.errorMsg
					});
				}
				self.setState({loading: false});
					
				if(recaptchaInstance){
					recaptchaInstance.reset();
				}
			});
		}
		else{
			self.setState({success: false, errorMsg: 'Recaptcha requires verification.'});
		}
	}
	else{
		self.setState({
			showCaptchaError: false,
			success: false,
			errorMsg: 'Unable to send inquiry.'
		});		
		if(recaptchaInstance){
			recaptchaInstance.reset();
		}
	}
}

function validateForm (self, tourPackage, name, emailAddress, contactNumber, message, termsOfAgreement) {
	let tourPackageError = formValidations.requiredTourPackageFieldErrorMsg('tour package', tourPackage);
	let nameError = formValidations.requiredNameFieldErrorMsg('name', name, CONFIG.NAME_LENGTH);
	let contactNumberError = formValidations.requiredMobileFieldErrorMsg('contact number', contactNumber, CONFIG.MOBILE_LENGTH);
	let emailAdError = formValidations.requiredEmailFieldErrorMsg(emailAddress, CONFIG.EMAIL_LENGTH);
	let messageError = formValidations.requiredMessageFieldErrorMsg(message, 0);
	let termsError = termsOfAgreement === false ? 'Terms of use agreement is required' : '';
	
	self.setState({
		tourPackageMsgError: tourPackageError,
		nameMsgError: nameError,
		contactNumberMsgError: contactNumberError,
		emailAdMsgError: emailAdError,
		messageMsgError: messageError,
		termsErrorMsg: termsError
	});
	
	return (tourPackageError === '' && nameError === '' && contactNumberError === '' && emailAdError === '' && messageError === '' && termsError === '');
}